// import { mapState } from 'vuex';
import config from '../libs/config';

export default {
  computed: {
    permissions() {
      return this.$store.state.app.permissionList;
    },
  },
  methods: {
    permissionFunc(name) { // 新增处理函数
      //  return utils.handlePermission(name)
      return this.permissions.includes(name) || !config.permission.other;
    },
  },
};
